<!-- RTK SOS告警 -->
<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="alarmStatus" slot-scope="{ row }">
        <el-tag :type="statusTag(row.alarmStatus)" size="small" effect="light">
          {{ statusText(row.alarmStatus) }}
        </el-tag>
      </template>
      <template slot="latestLocation" slot-scope="{ row }">
        <span>{{ formatLocation(row.latestLongitude, row.latestLatitude) }}</span>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="small" icon="el-icon-view" @click="handleView(row)">
          详情
        </el-button>
        <el-button
          v-if="row.alarmStatus === 1"
          type="text"
          size="small"
          icon="el-icon-check"
          @click="openHandle(row, 2)"
        >
          确认
        </el-button>
        <el-button
          v-if="row.alarmStatus !== 3"
          type="text"
          size="small"
          icon="el-icon-close"
          @click="openHandle(row, 3)"
        >
          关闭
        </el-button>
      </template>
    </avue-crud>

    <el-dialog title="SOS告警详情" :visible.sync="detailVisible" width="860px" append-to-body>
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="告警编号">{{ detail.alarmNo || "-" }}</el-descriptions-item>
        <el-descriptions-item label="处理状态">
          <el-tag :type="statusTag(detail.alarmStatus)" size="small" effect="light">
            {{ statusText(detail.alarmStatus) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="tagId">{{ detail.tagId || "-" }}</el-descriptions-item>
        <el-descriptions-item label="告警时间">{{ detail.reportTime || "-" }}</el-descriptions-item>
        <el-descriptions-item label="作业人员">{{ detail.employeeName || "-" }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ detail.employeePhone || "-" }}</el-descriptions-item>
        <el-descriptions-item label="当前位置">{{ detail.currentLocation || "-" }}</el-descriptions-item>
        <el-descriptions-item label="最近定位时间">{{ detail.latestLocationTime || "-" }}</el-descriptions-item>
        <el-descriptions-item label="上报坐标">
          {{ formatLocation(detail.reportLongitude, detail.reportLatitude) }}
        </el-descriptions-item>
        <el-descriptions-item label="最近定位">
          {{ formatLocation(detail.latestLongitude, detail.latestLatitude) }}
        </el-descriptions-item>
        <el-descriptions-item label="最后处理人">{{ detail.handleUserName || detail.handleUser || "-" }}</el-descriptions-item>
        <el-descriptions-item label="最后处理时间">{{ detail.handleTime || "-" }}</el-descriptions-item>
        <el-descriptions-item label="最后处理说明" :span="2">{{ detail.handleRemark || "-" }}</el-descriptions-item>
        <el-descriptions-item label="确认人">{{ detail.confirmUserName || detail.confirmUser || "-" }}</el-descriptions-item>
        <el-descriptions-item label="确认时间">{{ detail.confirmTime || "-" }}</el-descriptions-item>
        <el-descriptions-item label="确认说明" :span="2">{{ detail.confirmRemark || "-" }}</el-descriptions-item>
        <el-descriptions-item label="关闭人">{{ detail.closeUserName || detail.closeUser || "-" }}</el-descriptions-item>
        <el-descriptions-item label="关闭时间">{{ detail.closeTime || "-" }}</el-descriptions-item>
        <el-descriptions-item label="关闭说明" :span="2">{{ detail.closeRemark || "-" }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button type="primary" @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="handleForm.alarmStatus === 2 ? '确认SOS告警' : '关闭SOS告警'"
      :visible.sync="handleVisible"
      width="520px"
      append-to-body
    >
      <el-form ref="handleForm" :model="handleForm" :rules="handleRules" label-width="86px">
        <el-form-item label="告警编号">
          <span>{{ handleRow.alarmNo || "-" }}</span>
        </el-form-item>
        <el-form-item label="处理说明" prop="handleRemark">
          <el-input
            v-model="handleForm.handleRemark"
            type="textarea"
            :rows="4"
            maxlength="500"
            show-word-limit
            placeholder="请输入处理说明"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="handleVisible = false">取消</el-button>
        <el-button type="primary" :loading="handleLoading" @click="submitHandle">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, confirmAlarm, closeAlarm } from "./api";
import { getSearchTimeConfig } from "@/basic-common/util/common";

export default {
  name: "rtk-sos-alarm",
  mixins: [crudMixins],
  data() {
    return {
      form: {},
      detail: {},
      detailVisible: false,
      handleVisible: false,
      handleLoading: false,
      handleRow: {},
      handleForm: {
        id: "",
        alarmStatus: 2,
        handleRemark: "",
      },
      handleRules: {
        handleRemark: [{ required: true, message: "请输入处理说明", trigger: "blur" }],
      },
      apiConfig: { getList },
      option: {
        ...this.$store.state.publicOption,
        rowKey: "id",
        stripe: true,
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menuWidth: 180,
        column: [
          {
            label: "处理状态",
            prop: "alarmStatus",
            type: "select",
            search: true,
            slot: true,
            width: 110,
            dicData: [
              { label: "待处理", value: 1 },
              { label: "已确认", value: 2 },
              { label: "已关闭", value: 3 },
            ],
            props: {
              label: "label",
              value: "value",
            },
          },
          {
            label: "告警编号",
            prop: "alarmNo",
            search: true,
            minWidth: 180,
            overHidden: true,
          },
          {
            label: "tagId",
            prop: "tagId",
            search: true,
            minWidth: 120,
            overHidden: true,
          },
          {
            label: "作业人员",
            prop: "employeeName",
            search: true,
            minWidth: 110,
            overHidden: true,
          },
          {
            label: "联系电话",
            prop: "employeePhone",
            minWidth: 130,
            overHidden: true,
          },
          {
            label: "告警时间",
            prop: "reportTime",
            minWidth: 160,
          },
          {
            label: "当前位置",
            prop: "currentLocation",
            search: true,
            minWidth: 150,
            overHidden: true,
          },
          {
            label: "最近定位",
            prop: "latestLocation",
            slot: true,
            minWidth: 180,
          },
          {
            label: "最近定位时间",
            prop: "latestLocationTime",
            minWidth: 160,
          },
          {
            label: "处理人",
            prop: "handleUserName",
            minWidth: 120,
            overHidden: true,
          },
          {
            label: "处理时间",
            prop: "handleTime",
            minWidth: 160,
          },
          {
            label: "处理说明",
            prop: "handleRemark",
            minWidth: 180,
            overHidden: true,
          },
          {
            ...getSearchTimeConfig("告警时间", { type: "datetimerange" }),
            paramsKey: ["startTime", "endTime"],
          },
        ],
      },
    };
  },
  methods: {
    statusText(status) {
      const map = { 1: "待处理", 2: "已确认", 3: "已关闭" };
      return map[status] || "-";
    },
    statusTag(status) {
      const map = { 1: "danger", 2: "warning", 3: "success" };
      return map[status] || "info";
    },
    formatLocation(longitude, latitude) {
      if (longitude === undefined || longitude === null || latitude === undefined || latitude === null) {
        return "-";
      }
      return `${longitude}, ${latitude}`;
    },
    handleView(row) {
      this.detail = { ...row };
      this.detailVisible = true;
    },
    openHandle(row, alarmStatus) {
      this.handleRow = { ...row };
      this.handleForm = {
        id: row.id,
        alarmStatus,
        handleRemark: "",
      };
      this.handleVisible = true;
      this.$nextTick(() => {
        if (this.$refs.handleForm) {
          this.$refs.handleForm.clearValidate();
        }
      });
    },
    submitHandle() {
      this.$refs.handleForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.handleLoading = true;
        const request = this.handleForm.alarmStatus === 2 ? confirmAlarm : closeAlarm;
        request(this.handleForm)
          .then(() => {
            this.$message.success("处理成功");
            this.handleVisible = false;
            this.onLoad(this.page, this.query);
          })
          .finally(() => {
            this.handleLoading = false;
          });
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
